// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"51f0a6b2","149":"1410b683","476":"c3705a0a","488":"541a45fb","531":"a84e8425","711":"4dbdf358","737":"912a9784","751":"3c0f675f","833":"94e57f7c","834":"29aca572","896":"31382089","965":"ca687088","986":"45f7d43e"}[chunkId] + ".chunk.js";
};